export default __webpack_public_path__ + "static/media/errorsign.bcafafb4.gif";